import React from 'react';
export const useVideoPlayEffect = ({ compRef, isPlayingAllowed, autoPlayVideo, }) => React.useEffect(() => {
    if (!isPlayingAllowed) {
        compRef?.current?.stop();
    }
    else if (autoPlayVideo) {
        compRef?.current?.load();
    }
}, [compRef, isPlayingAllowed, autoPlayVideo]);
//# sourceMappingURL=useVideoPlayEffect.js.map